import { render, staticRenderFns } from "./KosmoInput.vue?vue&type=template&id=faaa7482&scoped=true"
import script from "./KosmoInput.vue?vue&type=script&lang=js"
export * from "./KosmoInput.vue?vue&type=script&lang=js"
import style0 from "./KosmoInput.vue?vue&type=style&index=0&id=faaa7482&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faaa7482",
  null
  
)

export default component.exports